module.exports = __webpack_public_path__ + "static/img/Eniksen_Logo_def.b564d00b.png";